import ClientSDK from '../../../App/ClientSDK'
import {IPermission, IApiPermission} from './IPermission'
import {AxiosResponse} from 'axios'
import Transformer from './Transformer'

class Client {

    static getUserPermissions = (userId: number): Promise<IPermission[]> => {
        return ClientSDK
            .instance()
            .get('person-permission/' + userId)
            .then((response: AxiosResponse): IPermission[] => {
                return response.data.list.map((data: IApiPermission) => Transformer.transform(data, userId))
            })
    }

    static updatePermissions = (permissions: IPermission[]) => {
        const userId = permissions[0].userId

        let url  = 'person-permission/' + userId + '/status';
        let data = {
            permissions: permissions.map((permission) => Transformer.reverseTransform(permission))
        }

        return ClientSDK.instance().post(url, data);
    }

}

export default Client
